import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faChartColumn,
  faGear,
  faCreditCard,
  faClipboardList,
  faHouse,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { accountsPortal, centralEnabled } from "@/services/centralAuth";
import { useAuth } from "@/context/AuthContext";
import { useCrmHub } from "@/context/SignalRContext";
import { adminRoles, editorRoles, ownerRole } from "@/helpers/roles";
interface NavItem {
  to: string;
  label: string;
  icon: IconDefinition;
  end?: boolean;
  newTab?: boolean;
}
export function useNavItems(): NavItem[] {
  const { session } = useAuth();
  const role = session?.role;
  const items: NavItem[] = [
    { to: "/", label: "Overview", icon: faHouse, end: true },
    { to: "/customers", label: "Customers", icon: faBuilding },
  ];
  if (role && editorRoles.includes(role)) {
    items.push(
      { to: "/actions/mine", label: "My actions", icon: faListCheck },
      { to: "/actions/team", label: "All actions", icon: faListCheck },
    );
  }
  if (role && adminRoles.includes(role)) {
    items.push({ to: "/orders", label: "Submissions", icon: faClipboardList });
  }
  items.push({ to: "/reports", label: "Reports", icon: faChartColumn });
  if (centralEnabled ? session?.canManageBilling : role === ownerRole) {
    items.push({ to: centralEnabled && session?.billingResourceId && session.billingAccountId ? `${accountsPortal}/subscriptions/${encodeURIComponent(session.billingResourceId)}?accountId=${encodeURIComponent(session.billingAccountId)}` : "/admin/subscription", label: "Subscription", newTab: true, icon: faCreditCard });
  }
  if (role && adminRoles.includes(role)) {
    items.push({ to: "/admin", label: "Admin", icon: faGear, end: true });
  }
  return items;
}
export function NewOrderBadge() {
  const { openOrderCount, ordersAttention } = useCrmHub();
  if (!openOrderCount) return null;
  const label = ordersAttention
    ? `${openOrderCount} submissions waiting, including new submissions`
    : `${openOrderCount} submissions waiting`;
  return (
    <span className={`nav-order-badge${ordersAttention ? " nav-order-badge--new" : ""}`} aria-label={label}>
      {openOrderCount}
    </span>
  );
}
export function SideNav({ onNavigate }: { onNavigate?: () => void }) {
  const items = useNavItems();
  return (
    <nav className="nav flex-column">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          target={item.newTab ? "_blank" : undefined}
          rel={item.newTab ? "noopener noreferrer" : undefined}
          className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          onClick={onNavigate}
        >
          <FontAwesomeIcon icon={item.icon} fixedWidth className="me-2" />
          {item.label}
          {item.to === "/orders" && <NewOrderBadge />}
        </NavLink>
      ))}
    </nav>
  );
}
